import React, {ReactNode} from "react";
import {SimpleSlideOverHeading, SlideOver} from "peggirkit";
import {useIntl} from "react-intl";

type Props = {
    showDetailsSection: boolean,
    setShowDetailsSection: React.Dispatch<React.SetStateAction<boolean>>,
    title: ReactNode,
    children: ReactNode,
};

const DetailsSlideOver = ({showDetailsSection, setShowDetailsSection, title, children}: Props) => {
    const intl = useIntl();

    return (
        <SlideOver
            open={showDetailsSection}
            setOpen={setShowDetailsSection}
            unmount={false}
            headingContainerClassname={"border-b border-gray-200 dark:border-slate-700"}
            bodyContainerClassname={"py-6"}
            heading={
                <SimpleSlideOverHeading
                    setOpen={setShowDetailsSection}
                    closeButton={{
                        show: true,
                        title: intl.formatMessage({id: "close"}),
                    }}
                >
                    {title}
                </SimpleSlideOverHeading>
            }
        >
            {children}
        </SlideOver>
    );
};

export default DetailsSlideOver;